import {
  REPORTING_TABLE_UNIT,
  REPORTING_TAB_TYPES,
  REPORTING_VIEW_TYPES,
} from "./types";

export const TAB_LABELS = {
  [REPORTING_VIEW_TYPES.PORTFOLIO]: {
    [REPORTING_TAB_TYPES.TOTAL]: "reportingPage:totalTabPortfolio",
    [REPORTING_TAB_TYPES.INDIVIDUAL]: "reportingPage:individualTabPortfolio",
  },
  [REPORTING_VIEW_TYPES.BUILDING]: {
    [REPORTING_TAB_TYPES.TOTAL]: "reportingPage:totalTabBuilding",
    [REPORTING_TAB_TYPES.INDIVIDUAL]: "reportingPage:individualTabBuilding",
  },
};

export const UNIT_LABELS = {
  [REPORTING_TABLE_UNIT.WEIGHT]: "kg",
  [REPORTING_TABLE_UNIT.EMISSIONS]: "kg CO₂e",
  [REPORTING_TABLE_UNIT.COST]: "£",
};

/** Badge colour for downstream handling types without a colour in Sanity. */
export const DEFAULT_DOWNSTREAM_HANDLING_COLOR = "#8A6C52";
